import { createFileRoute } from "@tanstack/react-router";
import { breadcrumbJsonLd } from "@/lib/breadcrumb-jsonld";
import { LegalLayout, COMPANY } from "@/components/site/LegalLayout";

export const Route = createFileRoute("/garantie")({
  head: () => ({
    meta: [
      { title: "Garantievoorwaarden — Elvion Group Nederland" },
      { name: "description", content: "Alles over garantie bij Elvion Group Nederland: wettelijke garantie volgens het Burgerlijk Wetboek en aanvullende fabrieksgarantie op onze producten." },
      { property: "og:title", content: "Garantievoorwaarden — Elvion Group Nederland" },
      { property: "og:description", content: "Bekijk de garantievoorwaarden van Elvion Group Nederland: wettelijke garantie, aanvullende fabrieksgarantie en hoe u een beroep doet op garantie." },
      { name: "robots", content: "index,follow" },
      { property: "og:url", content: "https://elvion-group.nl/garantie" },
    ],
    links: [{ rel: "canonical", href: "https://elvion-group.nl/garantie" }],
    scripts: [breadcrumbJsonLd([{ name: "Garantie", path: "/garantie" }])],
  }),
  component: () => (
    <LegalLayout
      title="Garantievoorwaarden"
      intro="Bij Elvion Group Nederland koopt u met de zekerheid van zowel de wettelijke garantie als — waar van toepassing — aanvullende fabrieksgarantie."
    >
      <h2>1. Wettelijke garantie</h2>
      <p>Op ieder product geldt de wettelijke garantie: een product moet doen wat u er redelijkerwijs van mag verwachten gedurende de te verwachten levensduur. Dit recht is vastgelegd in het Burgerlijk Wetboek (art. 7:17 BW) en is niet beperkt tot een vaste termijn.</p>

      <h2>2. Fabrieksgarantie</h2>
      <p>Veel producten worden geleverd met aanvullende fabrieksgarantie (vaak 2 tot 5 jaar). De specifieke termijn staat vermeld op de productpagina of in de bijgevoegde documentatie. Fabrieksgarantie laat de wettelijke rechten van de consument onverlet.</p>

      <h2>3. Wat valt onder garantie</h2>
      <ul>
        <li>Materiaal- en fabricagefouten</li>
        <li>Defecten bij normaal en correct gebruik conform de handleiding</li>
      </ul>

      <h2>4. Wat valt niet onder garantie</h2>
      <ul>
        <li>Schade door verkeerd gebruik, val, vocht of overspanning</li>
        <li>Onderdelen met normale slijtage (zoals accu's na intensief gebruik)</li>
        <li>Schade door reparatie of wijziging door derden zonder toestemming</li>
      </ul>

      <h2>5. Een beroep doen op garantie</h2>
      <ol>
        <li>Stuur een e-mail naar {COMPANY.email} met uw ordernummer en een omschrijving (foto's helpen).</li>
        <li>U ontvangt binnen 1 werkdag een reactie met instructies.</li>
        <li>Wij beoordelen het product en repareren, vervangen of vergoeden conform de wettelijke regels.</li>
      </ol>

      <h2>6. Geen extra kosten</h2>
      <p>Bij een terechte garantieclaim draagt {COMPANY.name} de kosten van transport, onderzoek en reparatie of vervanging.</p>

      <h2>Contact</h2>
      <p>{COMPANY.name} — {COMPANY.email} — {COMPANY.phone}</p>
    </LegalLayout>
  ),
});
